import { Box, HStack } from "@chakra-ui/react";
import Pagination from "./Pagination";
import MerchantLogo from "./MerchantLogo";
import { DownloadToExcelButton } from "./DownloadToExcelButton";
import PalommaLogoWithText from "./PalommaLogoWithText";
import SupportWidget from "./SupportWidget";

type TableProps<T extends Record<string, unknown>> = {
  fileName: string;
  items: T[];
  columns: readonly {
    key: string;
    label: string;
    format?: "datetime" | "none" | "currency" | "badge" | "status";
    exportTransform?: (value: T) => string | number;
  }[];
  pagination?: {
    tableKey: string;
    cursor: string | undefined;
    nextCursor: string | undefined;
    setCursor: (cursor: string | undefined) => void;
  };
};
type Props<T extends Record<string, unknown>> = {
  tableProps?: TableProps<T>;
};

const Footer = <T extends Record<string, unknown>>({
  tableProps,
}: Props<T>): JSX.Element => {
  return (
    <Box
      mt="auto"
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <HStack>
        {tableProps && (
          <>
            {tableProps?.pagination && (
              <Pagination
                tableKey={tableProps?.pagination?.tableKey}
                itemsCount={tableProps?.items.length}
                cursor={tableProps?.pagination?.cursor}
                nextCursor={tableProps?.pagination?.nextCursor}
                setCursor={tableProps?.pagination?.setCursor}
              />
            )}
            <DownloadToExcelButton
              fileName={tableProps?.fileName || "data"}
              items={tableProps?.items || []}
              tableColumns={tableProps?.columns || []}
            />
          </>
        )}
      </HStack>
      <Box display={"flex"} gap={2} alignItems={"center"}>
        <MerchantLogo />
        <PalommaLogoWithText width={120} height={120} />
        <SupportWidget />
      </Box>
    </Box>
  );
};

export default Footer;
